import { PersonalDetailsUrls, get } from '@mobi/account/Utils'

export const useAutoCompleteAddressList = () => {
  return async function search(search: string) {
    try {
      const addresses = await get<{
        items: string[]
      }>(PersonalDetailsUrls.getAutoAddressList(search, '15'))
      return addresses.items.map(item => ({ value: item, id: item }))
    } catch {
      return Promise.reject()
    }
  }
}
